import axios from 'axios';
import { getActiveContentDateRange } from './activeContentDateRange';

const baseUrl = process.env.REACT_APP_API_URL || 'https://api.iskenderun.bel.tr/api';

export const getActiveAdvertisements = async (pageNum = 1, pageSize = 20, searchTerm = '', sortBy = '') => {
  try {
    const { startDate, endDate } = getActiveContentDateRange();

    const response = await axios.post(`${baseUrl}/Adversitement/GetActiveAdvertisements`, {
      pageNum,
      pageSize,
      searchTerm,
      sortBy,
      startDate,
      endDate
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching active advertisements:', error);
    throw error;
  }
};

export const getAdvertisementByGuid = async (guid) => {
  try {
    console.log('Sending request with guid:', guid);
    const response = await axios.post(`${baseUrl}/Adversitement/GetAdvertisementsByGuid`, {
      guid: guid
    });
    console.log('Response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching advertisement details:', error.response?.data || error.message);
    throw error;
  }
};
